import axios from '../../config/axiosConfig';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { IItemRequest } from '../../shared';

import {QueryResultsActionTypes} from '../queryResults/models';
import { loadPDSelectorsFailure, loadPDSelectorsSuccess } from './explorePanel.actions';
import { ExplorePanelActionTypes, ExplorePerformanceDataSelectorsResponse } from './models';

/**
 * Fetches the appropriate performance data selectors for the given ndeSystemId
 */
export function* loadPDSelectorsStartAsyncSaga({payload}: {payload: IItemRequest; type: string}): Generator {
  try {

    const params = {
      ndeSystemId: payload.SystemID,
      subjectId: payload.SubjectCode,
    };
    const response = yield axios.get<ExplorePerformanceDataSelectorsResponse>('api/queryResults/GetExplorePerformanceSelectors', {
      params
    })
      .then((res) => res.data);
    yield put(loadPDSelectorsSuccess(<ExplorePerformanceDataSelectorsResponse>response));
  } catch (error) {
    yield put(loadPDSelectorsFailure(error));
  }
}

/**
 * Listens for LOAD_QUERY_RESULTS_START action, dispatchs loadPDSelectorsStartAsyncSaga
 */
export function* loadPDSelectorsStartSaga(): Generator {
  yield takeLatest(
    [QueryResultsActionTypes.LOAD_QUERY_RESULTS_START, ExplorePanelActionTypes.LOAD_SELECTORS_START],
    loadPDSelectorsStartAsyncSaga
  );
}

/**
 * Composite of all explorePanel sagas that are listening for external actions
 */
export function* explorePanelSagas(): Generator {
  yield all([call(loadPDSelectorsStartSaga)]);
}

export default explorePanelSagas;